import { actionTypes } from 'actions/actionTypes'
import { feLoggingLogEvent, logLevels } from 'actions/log'
import statusActions from 'actions/status'
import {
  checkoutPostSignup,
  clearGoustoRef,
  handleCheckoutError,
} from 'routes/Checkout/checkoutActions'
import { getPaymentData, getPaymentProvider } from 'routes/Checkout/checkoutPaymentSelectors'
import { signupPayment } from 'routes/Checkout/checkoutPaymentsApis'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'
import { Pricing } from 'routes/Menu/domains/pricing'
import { getSessionId } from 'selectors/cookies'

export const checkoutSignupPayment: CheckoutActionCreator =
  (sourceId: string, { pricing }: { pricing: Pricing }) =>
  async (dispatch, getState) => {
    dispatch(feLoggingLogEvent(logLevels.info, 'checkoutSignupPayment started'))
    try {
      const state = getState()
      const sessionId = getSessionId()
      const provider = getPaymentProvider(state)
      const reqData = getPaymentData(state)

      if (sourceId) {
        reqData.card_token = sourceId
      }

      await signupPayment(reqData, provider, sessionId)
      dispatch(
        feLoggingLogEvent(
          logLevels.info,
          'checkoutSignupPayment: signupPayment succeeded, proceed to checkoutPostSignup',
        ),
      )
      await dispatch(checkoutPostSignup({ pricing }))
    } catch (err) {
      dispatch(
        feLoggingLogEvent(
          logLevels.error,
          `checkoutSignupPayment: Signup payment failed: ${(err as Error).message}`,
        ),
      )
      await dispatch(handleCheckoutError(err, 'checkoutSignupPayment'))
    } finally {
      dispatch(clearGoustoRef())
      dispatch(statusActions.pending(actionTypes.CHECKOUT_SIGNUP, false))
      dispatch(feLoggingLogEvent(logLevels.info, 'checkoutSignupPayment: in finally'))
    }
  }
